__turbopack_context__.v({
  "column-options": "styles-module-scss-module__8x3m4a__column-options",
  "column_data": "styles-module-scss-module__8x3m4a__column_data",
  "column_data_range": "styles-module-scss-module__8x3m4a__column_data_range",
  "divider": "styles-module-scss-module__8x3m4a__divider",
  "headerCell": "styles-module-scss-module__8x3m4a__headerCell",
  "selectedRow": "styles-module-scss-module__8x3m4a__selectedRow",
  "tableBody": "styles-module-scss-module__8x3m4a__tableBody",
  "tableHead": "styles-module-scss-module__8x3m4a__tableHead",
  "tableWrapper": "styles-module-scss-module__8x3m4a__tableWrapper",
  "tbody": "styles-module-scss-module__8x3m4a__tbody",
});
